import { useIntl } from "react-intl";

import testIds from "constants/testIds";
import Textarea from "components/v2/Textarea/Textarea";
import { stopTestId } from "@RequestFormV2/utils/testIds";
import { StopPlanningSlice } from "@RequestFormV2/sections/Schedule/hooks/useStopPlanning";
import StopPlanningToggleGroup from "@RequestFormV2/sections/Schedule/components/StopCard/ScheduleSection/StopPlanningToggleGroup";

interface StopInstructionsProps {
  planning: StopPlanningSlice;
  stopIndex: number;
}

export default function StopInstructions({ planning, stopIndex }: StopInstructionsProps) {
  const intl = useIntl();
  const { showNotes, handleShowNotes, notesKey } = planning;

  return (
    <StopPlanningToggleGroup
      isVisible={showNotes}
      addLabel={intl.formatMessage({
        id: "request-form.schedule.planning.addInstruction",
        defaultMessage: "Add instruction",
      })}
      removeLabel={intl.formatMessage({
        id: "request-form.schedule.planning.removeInstruction",
        defaultMessage: "Remove instruction",
      })}
      onToggle={handleShowNotes}
    >
      <Textarea
        name={notesKey}
        label={intl.formatMessage({
          id: "request-form.schedule.planning.instructions",
          defaultMessage: "Instructions",
        })}
        testId={stopTestId(testIds.REQUEST_FORM_SCHEDULE_MULTISTOP_STOP_NOTES_PREFIX, stopIndex)}
      />
    </StopPlanningToggleGroup>
  );
}
